// Shared reading of the Mux live-stream telemetry the backend publishes on cme-common
// (session.data.health, appended by the cmehostinghealth handler).
// Used by the Stream Health card and by the Go Live gate, so both always agree on what
// "started" means.
//
//   Started = Mux is receiving the vendor's RTMP feed (is_live / progress.state)
// health.status is deliberately not read: it is the Mux asset status ("ready" as soon as
// the recording exists), so it says nothing about whether the feed is healthy.
// Only "started" is read - encoding details (tier, fps, audio) are not shown anywhere.
export function deriveStreamHealth(health) {
  if (!health || typeof health !== "object" || Array.isArray(health)) return null;
  const progressState = String(health.progress?.state || "").toLowerCase();

  // is_live is Mux's own answer and wins when present; progress.state only stands in
  // for payloads that do not carry is_live at all.
  const started = typeof health.is_live === "boolean" ? health.is_live : progressState === "live";

  return { started };
}
